const imageNameNormalizer = (value: string) => value.split('.')[0].replace(/\s/g, '')

export default imageNameNormalizer
